module.exports = __webpack_public_path__ + "static/media/58.9257d66c.gif";